const ExceptionalCareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M58.6666 29.5411V31.9944C58.6633 37.7449 56.8013 43.3402 53.3581 47.946C49.915 52.5517 45.0753 55.921 39.5609 57.5515C34.0464 59.182 28.1526 58.9862 22.7585 56.9933C17.3644 55.0005 12.759 51.3174 9.62915 46.4933C6.4993 41.6692 5.0127 35.9626 5.39106 30.2246C5.76942 24.4866 7.99247 19.0246 11.7287 14.6533C15.4649 10.2819 20.514 7.23545 26.1231 5.96815C31.7322 4.70086 37.6006 5.28066 42.8533 7.6211"
        stroke="#06AEB3"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.6667 10.6641L32 37.3574L24 29.3574"
        stroke="#FFA473"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExceptionalCareIcon;
